import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Box, Button, Flex, Heading, Text, useColorModeValue } from '@chakra-ui/react';
import { TiPiOutline } from "react-icons/ti";
import { useNavigate } from 'react-router-dom';

function NotFound() {
  const navigate = useNavigate();
  const bgColor = useColorModeValue('#fafaf7', 'gray.800');
  const textColor = useColorModeValue('gray.800', 'gray.100');

  return (
    <Box>
      <Flex
        minH="100vh"
        align="center"
        justify="center"
        bg={bgColor}
        px={4}
        direction="column"
      >
        <Box maxW="xl" textAlign="center">
          <DotLottieReact
            src="https://lottie.host/89999ed3-db35-4ffc-b9bd-83c7ca975e9e/rZOxjqmG4t.lottie"
            loop
            autoplay
            style={{ width: '300px', height: '300px', margin: '0 auto' }}
          />

          <Flex align="center" justify="center" mb={6}>
            <TiPiOutline size={32} color="#3182CE" />
            <Heading as="h1" size="xl" ml={2} color={textColor}>
              PiePOS
            </Heading>
          </Flex>

          <Heading as="h2" size="lg" mb={4} color={textColor}>
            Oops! Page Not Found
          </Heading>

          <Text fontSize="lg" mb={8} color="gray.600">
            The page you're looking for doesn't exist or has been moved.
          </Text>

          <Button
            colorScheme="blue"
            size="lg"
            onClick={() => navigate('/')}
            _hover={{ transform: 'translateY(-2px)', boxShadow: 'lg' }}
            transition="all 0.2s"
          >
            Return to Dashboard
          </Button>
        </Box>
      </Flex>
    </Box>
  );
}

export default NotFound;